/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Form_Aria_LabelInputs */

const en_styles_form_aria_label = /** @type {(inputs: Styles_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption Style Settings`)
};

const fr_styles_form_aria_label = /** @type {(inputs: Styles_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parametres de style de sous-titre`)
};

const de_styles_form_aria_label = /** @type {(inputs: Styles_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitelstil-Einstellungen`)
};

const it_styles_form_aria_label = /** @type {(inputs: Styles_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni stile didascalia`)
};

const ru_styles_form_aria_label = /** @type {(inputs: Styles_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки стиля подписи`)
};

const es_styles_form_aria_label = /** @type {(inputs: Styles_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración del estilo de subtítulos`)
};

const zh_cn2_styles_form_aria_label = /** @type {(inputs: Styles_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题样式设置`)
};

const ja_styles_form_aria_label = /** @type {(inputs: Styles_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションスタイルの設定`)
};

const hi_styles_form_aria_label = /** @type {(inputs: Styles_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन शैली सेटिंग्स`)
};

const pt_pt2_styles_form_aria_label = /** @type {(inputs: Styles_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de estilo de legenda`)
};

/**
* | output |
* | --- |
* | "Caption Style Settings" |
*
* @param {Styles_Form_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_form_aria_label = /** @type {((inputs?: Styles_Form_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Form_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_form_aria_label(inputs)
	if (locale === "de") return de_styles_form_aria_label(inputs)
	if (locale === "it") return it_styles_form_aria_label(inputs)
	if (locale === "ru") return ru_styles_form_aria_label(inputs)
	if (locale === "es") return es_styles_form_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_form_aria_label(inputs)
	if (locale === "ja") return ja_styles_form_aria_label(inputs)
	if (locale === "hi") return hi_styles_form_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_form_aria_label(inputs)
	return en_styles_form_aria_label(inputs)
});